<template>
  <v-img
    id="features"
    :src="require('@/assets/features.png')"
    :max-height="$vuetify.breakpoint.mdAndUp ? 700 : 'initial'"
  >
    <v-container class="align-content-center fill-height">
      <v-card-title class="text-h5 font-weight-bold mb-2"
        >List of Features</v-card-title
      >
      <v-card-text class="text-body mb-10 text-justify">
        Amplify lets you create and schedule customizable Jobs 
        and send Invoices to your Customers immediately.  
        Amplify helps you schedule both one-time and recurring 
        Jobs and includes In-app Messaging features to keep your 
        Customers informed.
      </v-card-text>
      <v-row fluid>
        <v-col
          cols="6"
          md="8"
          class="d-none d-sm-flex flex-column justify-center"
        >
          <v-row no-gutters>
            <v-col
              v-for="(item, i) in features"
              :key="i"
              class="mb-0 px-4 py-0"
              cols="6"
              sm="12"
            >
              <v-btn
                block
                outlined
                class="text-capitalize mb-3 py-4"
                @click="carousel = i"
                :large="$vuetify.breakpoint.smAndUp"
                :x-small="$vuetify.breakpoint.xs"
              >
                {{ item.title }}
                <v-spacer></v-spacer>
                <v-icon>{{ item.icon }}</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          class="mb-0 px-6 px-sm-3 py-0 py-sm-3 align-center order-first order-sm-last"
          :height="$vuetify.breakpoint.xs ? '500px' : 'initial'"
        >
          <v-carousel
            :vertical="!$vuetify.breakpoint.xs"
            :show-arrows="false"
            :hide-delimiters="!$vuetify.breakpoint.xs"
            hide-delimiter-background
            light
            v-model="carousel"
            :height="$vuetify.breakpoint.xs ? '250px' : '100%'"
          >
            <v-carousel-item
              v-for="(item, i) in features"
              :key="i"
              width="100%"
            >
              <v-card
                class="d-flex flex-column align-center justify-start justify-sm-center"
                :outlined="!$vuetify.breakpoint.xs"
                height="100%"
                width="100%"
              >
                <h4 class="text-h6 mb-4 text-center font-weight-bold">
                  {{ item.title }}
                </h4>
                <v-icon>{{ item.icon }}</v-icon>
                <v-card-text class="text-body-1 text-center">
                  {{ item.desc }}
                </v-card-text>
                <v-card-actions
                  v-if="item.link"
                >
                  <v-btn
                    outlined
                    :href="item.link.url"
                    target="_blank"
                  >
                    {{item.link.text}}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
      <v-row class="justify-center justify-sm-start">
        <v-card-subtitle class="text-no-wrap">
          <v-icon>mdi-gesture-tap</v-icon>
          {{
            $vuetify.breakpoint.xs
              ? "Swipe to view features"
              : "Click feature for more info"
          }}
        </v-card-subtitle>
      </v-row>
    </v-container>
  </v-img>
</template>

<script>
export default {
  name: "featuresPage",
  data() {
    return {
      features: [
        {
          title: "Job Scheduler",
          desc: "Schedule, track, and easily view details of your upcoming Jobs",
          icon: "mdi-calendar-blank",
        },
        {
          title: "In App Messages",
          desc: "Easily let Customers know when you are on- and off-site (with photos) and when an Invoice is ready.",
          icon: "mdi-forum",
        },
        {
          title: "Invoicing",
          desc: "Easily send Invoices to your customers; They will receive email or text notification of new Invoice",
          icon: "mdi-receipt",
        },
        {
          title: "Easy Transactions",
          desc: "Your Amplify subscription includes a Stripe Connect Express account at no additional cost. Stripe processing fees are deducted from your payouts.",
          link: {
            text: "More details here",
            url: "https://stripe.com/connect"
          },
          icon: "mdi-credit-card",
        },
        {
          title: "Fast Collections",
          desc: "Get your money faster with immediate Invoicing that lets your Customers easily pay by credit/debit card.",
          icon: "mdi-puzzle",
        },
        {
          title: "Organize Customers",
          desc: "Create and edit Customers; Add mowing-specific details (including options for multiple locations for one Customer)",
          icon: "mdi-clipboard-account",
        },
      ],
      carousel: 0,
    };
  },
};
</script>
